<miq-date
  [(currentValue)]="value"
  [required]="configuration.required"
  [handleTimezone]="withTimeZone"
  [disabled]="configuration.isDisabled"
  [minDate]="configuration?.minDate"
  [column]="configuration"
  [readonly]="readonly"
>
</miq-date>
